import React from "react";

export default function NotFound() {
  return (
    <div>
      <h1>Alien Page</h1>
    </div>
  );
}